/**
 * Formats a plain text string for use in an ID field by removing special characters and replacing spaces with dashes.
 * Also turns the string lowercase for consistency.
 * @param {string} string - source string.
 * @returns {string} formatted ID string.
 */
export const formatAsId = (text: string): string =>
	text.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9\-]/g, "");